// Returns width of elements in a 2x1 grid based on the Prismic gridLayout (ie. 1:2)
const gridWidth = (grid: string) => {
  const base = 33;
  if (grid === '1:1') return ['50%', '50%'];
  return grid.split(':').map(x => `${parseInt(x, 10) * base}%`);
};

export default gridWidth;
